import { render, staticRenderFns } from "./LicenseDevices.vue?vue&type=template&id=13b0527a&scoped=true&"
import script from "./LicenseDevices.vue?vue&type=script&lang=ts&"
export * from "./LicenseDevices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0527a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b0527a')) {
      api.createRecord('13b0527a', component.options)
    } else {
      api.reload('13b0527a', component.options)
    }
    module.hot.accept("./LicenseDevices.vue?vue&type=template&id=13b0527a&scoped=true&", function () {
      api.rerender('13b0527a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/LicenseDevices.vue"
export default component.exports